import React from 'react';
import { ArrowLeft } from 'lucide-react';

interface SessionAnalyticsSkeletonProps {
  onBack: () => void;
}

/**
 * Skeleton loader for the SessionAnalytics page.
 * Uses structured layout placeholders and the admin-skeleton shimmer class.
 */
export function SessionAnalyticsSkeleton({ onBack }: SessionAnalyticsSkeletonProps) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', width: '100%', margin: '0 auto', boxSizing: 'border-box' }}>
      {/* Header Skeleton */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
        <button
          onClick={onBack}
          style={{
            padding: '8px',
            borderRadius: '0',
            backgroundColor: 'rgba(255, 255, 255, 0.04)',
            color: 'var(--admin-card-text)',
            border: '1px solid var(--admin-card-border)',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <ArrowLeft size={18} />
        </button>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <div className="admin-skeleton" style={{ width: '320px', height: '32px' }} />
          <div className="admin-skeleton" style={{ width: '200px', height: '14px' }} />
        </div>
      </div>

      {/* Main Skeleton Card */}
      <div style={{ background: 'var(--admin-card-bg)', borderRadius: '0', border: '1px solid var(--admin-card-border)', display: 'flex', flexDirection: 'column' }}>
        {/* Tabs Skeleton */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '24px', padding: '16px 20px', borderBottom: '1px solid var(--admin-card-border)' }}>
          <div className="admin-skeleton" style={{ width: '80px', height: '16px' }} />
          <div className="admin-skeleton" style={{ width: '80px', height: '16px' }} />
        </div>

        {/* Content Skeleton */}
        <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
          {/* Top Stats Grid Skeleton */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '12px' }}>
            {[1, 2, 3, 4].map(i => (
              <div key={i} style={{ padding: '16px', borderRadius: '0', border: '1px solid var(--admin-card-border)', backgroundColor: 'rgba(255, 255, 255, 0.02)', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div className="admin-skeleton" style={{ width: '90px', height: '12px' }} />
                  <div className="admin-skeleton" style={{ width: '24px', height: '24px' }} />
                </div>
                <div className="admin-skeleton" style={{ width: '60px', height: '24px' }} />
              </div>
            ))}
          </div>

          {/* Charts Grid Skeleton */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '16px' }}>
            <div style={{ padding: '16px', borderRadius: '0', border: '1px solid var(--admin-card-border)', backgroundColor: 'rgba(255, 255, 255, 0.02)', height: '260px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div className="admin-skeleton" style={{ width: '140px', height: '16px' }} />
              <div className="admin-skeleton" style={{ flex: 1, border: '1px dashed var(--admin-card-border)' }} />
            </div>

            <div style={{ padding: '16px', borderRadius: '0', border: '1px solid var(--admin-card-border)', backgroundColor: 'rgba(255, 255, 255, 0.02)', height: '260px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div className="admin-skeleton" style={{ width: '140px', height: '16px' }} />
              <div className="admin-skeleton" style={{ flex: 1, border: '1px dashed var(--admin-card-border)' }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
